export type NotNull<T> = Exclude<T, null>;
/**
 * @deprecated - 6 years old and redundant, use `x !== null` instead.
 */
export const isNotNull = <T>(input: null | NotNull<T>): input is NotNull<T> =>
  input !== null;

export type NotUndefined<T> = Exclude<T, undefined>;
/**
 * @deprecated - 6 years old and redundant, use `x !== undefined` instead.
 */
export const isNotUndefined = <T>(
  input: undefined | NotUndefined<T>
): input is NotUndefined<T> => input !== undefined;

/**
 * Checks if value is nullish (null or undefined). Equivalent to a `== null` check.
 *
 * @param value the value to check
 * @returns true if value is nullish (null or undefined), otherwise false
 * @deprecated - 6 years old and redundant, use `x == null` instead.
 */
export const isNullish = (value: unknown): value is undefined | null =>
  value === null || value === undefined;
